/* MARKETS */
const GB = 'gb';
const ZA = 'za';
const IN = 'in';
const AU = 'au';
const GLOBAL = 'global';

// TODO: Remove invalid locales and update locales to use correct casings (e.g. en-GB)
/* LOCALES */
const EN_GB = 'en-gb';
const EN_ZA = 'en-za';
const EN_IN = 'en-in'; // Remove
const HI_IN = 'hi-in'; // Update to 'hi'
const EN_AU = 'en-au';

/* CURRENCIES */
const GBP = 'GBP';
const INR = 'INR';
const ZAR = 'ZAR';
const AUD = 'AUD';
const GBP_SYMBOL = '£';
const INR_SYMBOL = '₹';
const ZAR_SYMBOL = 'R';
const AUD_SYMBOL = '$';

/* TIMEZONES */
const GB_TIMEZONE = 'Europe/London';
const ZA_TIMEZONE = 'Africa/Johannesburg';
const IN_TIMEZONE = 'Asia/Kolkata';
const AU_TIMEZONE = 'Australia/Sydney';

/* TIMEZONE ABBREVIATIONS */
const GB_TIMEZONE_ABBREVIATION = 'GMT';
const BST_TIMEZONE_ABBREVIATION = 'BST';
const ZA_TIMEZONE_ABBREVIATION = 'SAST';
const IN_TIMEZONE_ABBREVIATION = 'IST';
const AU_TIMEZONE_ABBREVIATION = 'AEST';

/* DIALING CODES */
const GB_DIALING_CODE = '+44';
const ZA_DIALING_CODE = '+27';
const IN_DIALING_CODE = '+91';
const AU_DIALING_CODE = '+61';

module.exports = {
    GB,
    ZA,
    IN,
    AU,
    GLOBAL,
    EN_GB,
    EN_ZA,
    EN_IN,
    HI_IN,
    EN_AU,
    GBP,
    INR,
    ZAR,
    AUD,
    GBP_SYMBOL,
    INR_SYMBOL,
    ZAR_SYMBOL,
    AUD_SYMBOL,
    MARKETS: [GB, ZA, IN, AU],
    LOCALES: [EN_GB, EN_ZA, EN_IN, HI_IN, EN_AU],
    DEFAULT_MARKET: GB,
    DEFAULT_LOCALE: EN_GB,
    CURRENCY: {
        [GB]: GBP,
        [IN]: INR,
        [ZA]: ZAR,
        [AU]: AUD,
    },
    CURRENCY_SYMBOLS: {
        [GBP]: GBP_SYMBOL,
        [INR]: INR_SYMBOL,
        [ZAR]: ZAR_SYMBOL,
        [AUD]: AUD_SYMBOL,
    },
    TIMEZONE: {
        [EN_GB]: GB_TIMEZONE,
        [EN_ZA]: ZA_TIMEZONE,
        [EN_IN]: IN_TIMEZONE,
        [EN_AU]: AU_TIMEZONE,
    },
    TIMEZONE_ABBREVIATION: {
        [EN_GB]: GB_TIMEZONE_ABBREVIATION,
        [EN_ZA]: ZA_TIMEZONE_ABBREVIATION,
        [EN_IN]: IN_TIMEZONE_ABBREVIATION,
        BST: BST_TIMEZONE_ABBREVIATION,
        [EN_AU]: AU_TIMEZONE_ABBREVIATION,
    },
    DIALING_CODES: [GB_DIALING_CODE, ZA_DIALING_CODE, IN_DIALING_CODE, AU_DIALING_CODE],
    DIALING_CODE: {
        [GB]: GB_DIALING_CODE,
        [ZA]: ZA_DIALING_CODE,
        [IN]: IN_DIALING_CODE,
        [AU]: AU_DIALING_CODE,
    },
};
